import { Controller } from "@hotwired/stimulus"

// Swaps the "Lire la suite" link from the SEO page URL (default, for crawlers)
// to opening the entrypoint drawer (for JS-enabled users).
// The SEO URL stays in the HTML source for search engines.
export default class extends Controller {
  static targets = ["link"]

  linkTargetConnected(link) {
    const drawerUrl = link.dataset.drawerUrl
    if (!drawerUrl) return

    // Store original SEO href as fallback
    link.dataset.originalHref = link.href

    // Swap to drawer behavior
    link.href = drawerUrl
    link.dataset.turboFrame = "drawer"
  }
}
